"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-six/sections/bannerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BannerSectionH1sItem = {
    key: Key | null | undefined;
};
export type HomeSixBannerSectionGeneratedProps = {
    sectionDiv0Div0ClassName?: string;
    /** Default: "Your Pet’s" */
    sectionDiv0Div0Div0Div0H10H1Text?: ReactNode;
    /** Default: "Health, Our Top" */
    sectionDiv0Div0Div0Div0H10H1Text2?: ReactNode;
    /** Default: "Priority" */
    sectionDiv0Div0Div0Div0H10H1Text3?: ReactNode;
    sectionDiv0Div0Div0Div0H10H1Visible?: boolean;
    sectionDiv0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "banner-icon" */
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon-4.svg" */
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-icon" */
    sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon-5.svg" */
    sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Providing expert veterinary care with compassion, dedication, and love. From routine checkups to emergency care, we’re here to keep your pets happy" */
    sectionDiv0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "#" */
    sectionDiv0Div0Div0Link0LinkHref?: string;
    sectionDiv0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "View All Services" */
    sectionDiv0Div0Div0Link0Span0SpanText?: ReactNode;
    /** Default: "banner-img" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-img-7.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-img" */
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-img-1.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-icon" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon-6.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-icon" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon-7.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    bannerSectionH1s: BannerSectionH1sItem[];
    bannerSectionH1sItemWrapper?: (item: BannerSectionH1sItem, content: ReactNode) => ReactNode;
    bannerSectionH1sRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeSixBannerSectionGenerated: FC<HomeSixBannerSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0H10H1Text = "Your Pet’s",
    sectionDiv0Div0Div0Div0H10H1Text2 = "Health, Our Top",
    sectionDiv0Div0Div0Div0H10H1Text3 = "Priority",
    sectionDiv0Div0Div0Div0H10H1Visible,
    sectionDiv0Div0Div0Div0H10H1Renderer,
    sectionDiv0Div0Div0Div0H10H1Props,
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageAlt = "banner-icon",
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/banner-icon-4.svg",
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageAlt = "banner-icon",
    sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/banner-icon-5.svg",
    sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageProps,
    sectionDiv0Div0Div0Div0P0PText = "Providing expert veterinary care with compassion, dedication, and love. From routine checkups to emergency care, we’re here to keep your pets happy",
    sectionDiv0Div0Div0Link0LinkHref = "#",
    sectionDiv0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div0Link0Span0SpanText = "View All Services",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt = "banner-img",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-img-7.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt = "banner-img",
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/banner-img-1.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps,
    sectionImageWithBasePath0ImageAlt = "banner-icon",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/banner-icon-6.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "banner-icon",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/banner-icon-7.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionDiv0Div0ClassName,
    bannerSectionH1s,
    bannerSectionH1sItemWrapper,
    bannerSectionH1sRenderer,
}) => {
    return (
        <section className="banner-section-six section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-lg-7">
                        <div className="section-header section-header-six">
                            {renderNode(sectionDiv0Div0Div0Div0H10H1Visible, sectionDiv0Div0Div0Div0H10H1Renderer, (
                                <h1 className="section-title" {...(sectionDiv0Div0Div0Div0H10H1Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H10H1Text}
                                    {" "}
                                    {renderNode(sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                    {" "}
                                    {renderCollectionNode(
                                        bannerSectionH1s,
                                        (item: BannerSectionH1sItem) => (
                                            <br key={item.key} />
                                        ),
                                        bannerSectionH1sItemWrapper,
                                        bannerSectionH1sRenderer
                                    )}
                                    {sectionDiv0Div0Div0Div0H10H1Text2}
                                    <br />
                                    {" "}
                                    {renderNode(sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageVisible, sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageAlt} className="img-fluid img-one" {...(sectionDiv0Div0Div0Div0H10ImageWithBasePath1ImageProps ?? {})} />
                                    ))}
                                    {" "}
                                    {sectionDiv0Div0Div0Div0H10H1Text3}
                                    {" "}
                                </h1>
                            ))}
                            <p>{sectionDiv0Div0Div0Div0P0PText}</p>
                        </div>
                        {renderNode(sectionDiv0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Link0LinkRenderer, (
                            <SmartLink href={sectionDiv0Div0Div0Link0LinkHref} className="btn btn-primary" {...(sectionDiv0Div0Div0Link0LinkProps ?? {})}>
                                <span>
                                    <i className="isax isax-category" />
                                    {sectionDiv0Div0Div0Link0Span0SpanText}
                                </span>
                            </SmartLink>
                        ))}
                    </div>
                    <div className="col-lg-5">
                        <div className="banner-img">
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt} className="img-fluid img-two" {...(sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid icon-one" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid icon-two" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSixBannerSectionGenerated;
